import { FC, useEffect } from 'react';
import { Button } from '@glomopay/shadcn/button';

import { analytics, AnalyticsEventName, AppErrorCode } from '@/features/analytics/public';

const reportedErrors = new WeakSet<object>();

interface ErrorPageProps {
  error?: unknown;
}

// Uses a plain anchor (full navigation) rather than a router Link so it renders
// safely both as the route errorComponent and as the top-level Sentry fallback,
// which mounts outside the RouterProvider.
export const ErrorPage: FC<ErrorPageProps> = ({ error }) => {
  useEffect(() => {
    if (error instanceof Object) {
      if (reportedErrors.has(error)) return;
      reportedErrors.add(error);
    }
    analytics.track(AnalyticsEventName.INVESTOR_APP_FAILED, { error_code: AppErrorCode.RENDER_ERROR });
  }, [error]);

  return (
    <main className='bg-bg-default flex min-h-dvh flex-col items-center justify-center gap-6 px-6 text-center'>
      <h1 className='text-text-primary text-2xl font-semibold'>Something went wrong</h1>
      <p className='text-text-secondary'>An unexpected error occurred. Please try again.</p>
      <Button asChild>
        <a href='/'>Go Back Home</a>
      </Button>
    </main>
  );
};
